import axios from "axios"
import { encriptar } from "../../../utilities/encriptacion";
import Swal from "sweetalert2";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export const addHealthTracker = (params = {}, setShowBienestar) => {
    
    axios.post(`${apiUrl}/monitor/add-heathTraker`, params)
        .then((res) => {
            
            if(res.data.AGREGADO==1)
            {
                const auth = encriptar("true", key);
                sessionStorage.setItem("authMonitor", auth);
                // sessionStorage.setItem("token", res.data);
                window.location.href = '/';
            }
        })
        .catch((error_tracker) => {
            Swal.fire({
                icon:"error",
                text:"Credenciales no validas"
            })
            console.log("error_tracker", error_tracker);
        })



}